package gr.tech.lkpksignature.components.SignaturePad

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.browser.api
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromString
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.w3c.fetch.Response

//TODO Logging for if these are not working.

@Serializable
data class SignatureRequest(
    val id: Int?,
    val signautre: String
)

//Function to load Signature Pad
//Notes: DOMContentLoaded listener is needed, as this code will run before HTML is rendered, causing null error
@Composable
fun loadSigPad() {
    js(
        """
        var canvas = document.getElementById('canvas');
        if (canvas) {
            window.signaturePad = new SignaturePad(canvas, {
                backgroundColor: 'rgb(255, 255, 255)',
                penColor: 'rgb(0, 0, 0)'
            }); //Global. To reference in saveSignature().   
        }
        """
    )
}

//Function to save Signature from the canvas.
fun saveSigPad(): String? {
    val signedUrl: String? = null
    js(
        """
        if (window.signaturePad) {
            if (!window.signaturePad.isEmpty()) {
                var dataURL = window.signaturePad.toDataURL("image/jpeg", 0.5);
                signedUrl = dataURL; //Bringing back to Kobweb
            } else {
                signedUrl = null
            }
        }
        """
    )
    console.log(signedUrl)
    return signedUrl
}

//Function to clear Signature canvas.
fun clearSigPad() {
    js(
        """
        if (window.signaturePad) {
            window.signaturePad.clear();
        }
        """
    )
}

//Function to check if Signature is entered.
fun checkSigPad() {
    val signed: Boolean? = null
    js(
        """
        if (window.signaturePad) {
           signed = window.signaturePad.isEmpty();
        }
        """
    )
}